module.exports = __webpack_public_path__ + "static/img/integral.bf1e817.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diy/integral.png
// module id = 9VpQ
// module chunks = 174